var CurrentUser = require("lib/account/CurrentUser");
var OrgTypes = require("lib/academic/OrgTypes");

var StudentHomePageStreamlined = require("components/users/students/StudentHomePageStreamlined");
var StudentHomePageVertical = require('components/users/students/StudentHomePageVertical')
var AdminHomePage = require("components/users/admins/AdminHomePage");
var CustomAdminHomePage = require("components/users/admins/CustomAdminHomePage");
var TeacherHomePage = require("components/users/teachers/TeacherHomePage");
var CustomTeacherHomePage = require("components/users/teachers/CustomTeacherHomePage");
var WhooosReadingServices = require("lib/web/WhooosReadingServices")

class HomePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		if (CurrentUser.isSignedIn()) {
			var params = _.extend({}, this.props.match.params, { id: CurrentUser.get().id });
			var match = _.extend({}, this.props.match, { params: params });
		}

		var pageContent = [];

		if (!CurrentUser.isSignedIn()) {
			var pageContent = (<div />);

		} else if (CurrentUser.isStudent()) {
			var pageContent = (<div><StudentHomePageVertical {...this.props} match={match} /></div>)

		} else if (CurrentUser.isTeacherAdmin()) {
			var pageContent = <CustomTeacherHomePage {...this.props} match={match} />

		} else if (CurrentUser.isSchoolAdmin()) {
			var pageContent = <CustomAdminHomePage {...this.props} match={match} adminOrgLevel={OrgTypes.SCHOOL_ORG} />

		} else if (CurrentUser.isDistrictAdmin()) {
			var pageContent = <CustomAdminHomePage {...this.props} match={ match } adminOrgLevel={ OrgTypes.DISTRICT_ORG } />			
		}

		return (
			<div>
				{ pageContent }
			</div>
		)
	}

	componentDidMount() {
		if (!CurrentUser.isSignedIn()) {
			window.location.href = WhooosReadingServices.OuterPages.url("/")
		}
	}
};

HomePage.propTypes = PageStrictPropTypes({
});

module.exports = HomePage;


// WEBPACK FOOTER //
// ./modules/components/technical/HomePage.js